<template>
  <v-app id="adminpro" :class="`${!$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`">
      <router-view />
  </v-app>

</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { mapGetters } from "vuex";

export default {
  name: 'App',

  components: {
    
  },
  data: () => ({
    //signedIn:false,
    activeUsers:[],
    route: "", //test
    windowed:null,
    banner:false,
  }),
  computed: {
        ...mapGetters(["userprof", "signedIn"])
  },
  async beforeCreate() {
    try {
      await this.$Amplify.Auth.currentAuthenticatedUser()
        .then((user) => (this.$store.dispatch("updateUser",user)))
        .catch((err) => console.log(err));
      //this.signedIn = true;
      this.$store.dispatch("updateSignedIn",true);
    } catch (err) {
      //this.signedIn = false;
      this.$store.dispatch("updateSignedIn",false);
    }
    AmplifyEventBus.$on("authState", (info) => {
      //this.signedIn = info === "signedIn";
      this.$store.dispatch("updateSignedIn",info === "signedIn");
    });
    console.log("SIGNED IN: " + this.signedIn);

  if(this.signedIn){
      // this.$store.dispatch('WSConnect',"wss://hkm37j7b07.execute-api.us-east-1.amazonaws.com/production?connectionType=status&jwt="+this.$store.getters.jwt);
      
      this.$store.dispatch("updateUserInfo");        

      console.log("ROUTE: " + this.$route.name);
      if(this.$route.name == "Auth"){
        this.$router.push({ name: "Home" });
      }
    }
  },
};
</script>
